import { render, staticRenderFns } from "./CustomerGroupUpdate.vue?vue&type=template&id=894a0a8c&"
import script from "./CustomerGroupUpdate.vue?vue&type=script&lang=ts&"
export * from "./CustomerGroupUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports